'use client'

import classNames from 'classnames'
import { useCallback, useState } from 'react'
import Sticky from 'react-stickynode'
import ListingBar from './listingBar'
import PropertyBar from './propertyBar'
import { isShowTrackButton } from '@utils/house'

export default function TopFixedBar({
  data,
  enabled = true,
  className = '!h-0',
  barClick
}) {

  // 是否展示top bar
  const [showTopBar, setShowTopBar] = useState(!enabled)
  // 监听top bar状态
  const stateChangeHandle = useCallback(({ status }) => {
    setShowTopBar(status === Sticky.STATUS_FIXED)
  }, [setShowTopBar])

  return (
    <Sticky enabled={enabled} onStateChange={stateChangeHandle} top={0} innerZ={51} className={className}>
      <div className={classNames('bg-white shadow-card', showTopBar ? 'animate-expansion' : 'hidden')} style={{ animationFillMode: 'none' }}>
        {
          showTopBar && (
            <div className='section-wrap'>
              {
                isShowTrackButton(data)
                  ? <PropertyBar data={data} barClick={barClick}></PropertyBar>
                  : <ListingBar data={data} barClick={barClick}></ListingBar>
              }
            </div>
          )
        }
      </div>
    </Sticky>
  )
}